import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { jumpUrl } from "../../utils/tool";
import { get } from "../../utils/request";
import DayUpTip from "./components/DayUpTip";
import "./style.css";
let toCollage = "close";
let noSenior = "close";
class DayUp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msg: "",
    };
  }

  componentDidMount = () => {
    document.title = "浙考之家-每日高升";
    this.requestToolConfig();
  };
  componentDidUpdate = () => {
    if (this.props.userInfo.isBuy === false) {
      jumpUrl("pay");
    }
  };
  render() {
    return (
      <div className="day_up_box">
        <div className="day_up_broadcast">
          <img alt="" src={require("../../images/dayup/喇叭.png")}></img>
          <marquee
            scrollamount="3"
            style={{
              width: "89%",
              position: "relative",
              top: "2px",
              fontsize: "14px",
              color: "#5d5d5d",
            }}
          >
            电脑版网址：zhekaozhijia.com或微信电脑版可用，使用订购的手机号+密码登录，忘记密码可点右下角我的重新设置，添加微信：2911797280，邀请入新高考交流群。
          </marquee>
        </div>
        <NavLink to="/intelligentbigdata/home">
          <img alt="" src={require("../../images/dayup/home/01.png")}></img>
        </NavLink>
        <NavLink
          to="/tocollege/condition"
          style={{ paddingTop: "7px" }}
          onClick={(event) => this.preventHelper(event)}
        >
          <img alt="" src={require("../../images/dayup/home/02.png")}></img>
        </NavLink>
        <NavLink to="/articlelist?categoryId=3" style={{ paddingTop: "7px" }}>
          <img alt="" src={require("../../images/dayup/home/03.png")}></img>
        </NavLink>
        <NavLink to="/trinity/condition" style={{ paddingTop: "7px" }}>
          <img alt="" src={require("../../images/dayup/home/04.png")}></img>
        </NavLink>
        <NavLink
          style={{ paddingTop: "7px" }}
          // onClick={(event) => this.preventSchool(event)}
          to="/articledetail/Rv2Iq2"
        >
          <img alt="" src={require("../../images/dayup/home/06.png")}></img>
        </NavLink>
        {this.state.msg ? (
          <DayUpTip
            handCloseDayUpTip={this.handCloseDayUpTip}
            msg={this.state.msg}
          ></DayUpTip>
        ) : null}
        <div style={{ height: "53px" }}></div>
      </div>
    );
  }

  /**
   * 获取工具的配置信息
   */
  requestToolConfig = () => {
    get("/public/v1/tool").then((res) => {
      res.data.forEach((element) => {
        if (element.name === "to_collage") {
          toCollage = element.value;
        }
        if (element.name === "no_senior") {
          noSenior = element.value;
        }
      });
    });
  };
  /**
   * 关闭每日高升
   */
  handCloseDayUpTip = () => {
    this.setState({
      msg: "",
    });
  };

  /**
   * 阻止志愿智能助手
   * @param {*} event
   */
  preventHelper = (event) => {
    if (toCollage === "close") {
      event.preventDefault(); //阻止默认事件
      this.setState({
        msg: "高考季会重新开放<br>",
      });
    } else {
      let userInfo = this.props.userInfo;
      if (noSenior === "close") {
        if (userInfo.year !== 2026) {
          event.preventDefault(); //阻止默认事件
          this.setState({
            msg: "非高三学子此功能暂不可用<br>后面会重新开放，感谢支持",
          });
        }
      }
    }
  };
  /**
   * 阻止三位一体
   * @param {*} event
   */
  preventTrinity = (event) => {
    event.preventDefault(); //阻止默认事件
    this.setState({
      msg: "20年省属三位一体报考已结束<br>21年报考前会重新开放",
    });
  };
  /**
   * 阻止招生章程
   * @param {*} event
   */
  preventSchool = (event) => {
    //event.preventDefault(); //阻止默认事件
    // this.setState({
    //   msg: "高考季会重新开放<br>",
    // });
  };
  /**
   * 关闭每日高升提示框
   */
  handleCloseDayUpTip = () => {
    this.setState({
      msg: "",
    });
  };
}
const mapStateToProps = (state) => {
  return {
    userInfo: state.user.userData.userInfo,
  };
};

export default connect(mapStateToProps)(DayUp);



// WEBPACK FOOTER //
// ./src/containers/DayUp/index.js